import WebFont from 'webfontloader'
import Lenis from '@studio-freight/lenis'
import CustomElement from './core/custom.js'
import Emitter from './core/emitter.js'
import App from './stores/app.js'
import Viewport from './stores/viewport.js'
import './core/router.js'
import { gsap, Quart } from 'gsap'

import WebglScene from './webgl/WebglScene'

// Components
import './components/AppearObject'
import './components/ParallaxObject'
import './components/VideoAutoplay'
import './components/PosterParallax'
import './components/DefaultSlider'
import './components/BlockClients'
import './components/CollapseObject'
import './components/ContentWithDialog.js'
import './components/ScrollTo'
import './components/BlockIndustries'
import './components/HeaderNav.js'
import './components/MobileNav'
import './components/NotificationCenter'
import './components/NotificationSimple.js'
import './components/BlockCaseStudyHeader.js'
import './components/NotificationCookie.js'
import './components/VideoParallax.js'
import './components/PlyrVideo.js'
import './components/CoverFlowSlider.js'
import './components/StickyFilters.js'
import './components/StickyFiltersMobile.js'
import './components/ResourceImage.js'
import './components/ResourceNav.js'
import './components/Cursor.js'
import './components/CursorTrigger.js'
import './components/VerticalsNav.js'
import './components/PortfolioView.js'
// import './components/HomeTitle.js'
import './components/ScrollObject.js'
import './components/LoadMore.js'
import './components/BlockCities.js'
import './components/BlockIntro.js'
import './components/KeepScrolling.js'
import './components/HubspotForm.js'
import './components/BlockWelcomeScreen.js'
import './components/BlockIntroVertical.js'
import './components/TimeClock.js'
import './components/ManagerItem.js'

let resizeTimer

window._firstLoad = true
window.customElements.define(
  'exclusible-app',
  class extends CustomElement {
    constructor() {
      super()

      // Preload Fonts
      WebFont.load({
        custom: {
          families: ['Louize Display', 'Plaax']
        },
        active: () => {
          this.fontsLoaded = true
          this.onDocumentReady()
        }
      })

      // Wait dom is loaded
      if (document.readyState !== 'loading') {
        document.body.style.display = null
        this.domLoaded = true

        requestAnimationFrame(() => {
          this.onDocumentReady()
        })
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          document.body.style.display = null
          this.domLoaded = true

          requestAnimationFrame(() => {
            this.onDocumentReady()
          })
        })
      }

      Emitter.on('webgl:ready', this.onWebglReady)

      if (window.webglIsReady) {
        this.onWebglReady()
      }
    }

    onWebglReady() {
      this.webglLoaded = true

      this.onDocumentReady()
    }

    onDocumentReady() {
      if (!this.fontsLoaded || !this.domLoaded || !this.webglLoaded) return

      if (window._firstLoad) {
        window._firstLoad = false

        Emitter.emit('document:ready')

        const loader = this.querySelector('.js-app-loader')

        if (loader) {
          gsap.to(loader, {
            opacity: 0,
            duration: 0.8,
            delay: 0.1,
            ease: Quart.easeOut,
            onComplete: () => {
              loader.style.display = 'none'
            }
          })
        }
      }
    }

    connectedCallback() {
      super.connectedCallback()

      const isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)

      App.lenis = new Lenis({
        duration: 1.2,
        lerp: 0.1,
        easing: (t) => 1 - Math.pow(1 - t, 4),
        infinite: false,
        autoResize: true
      })

      this._onUpdate = this.onUpdate.bind(this)

      requestAnimationFrame(this._onUpdate)
      onResize()
    }

    onUpdate(time) {
      App.lenis.raf(time)
      requestAnimationFrame(this._onUpdate)

      Emitter.emit('update')
    }
  }
)

function onResize() {
  // clearTimeout(resizeTimer);
  // resizeTimer = setTimeout(()=>{
  document.documentElement.style.setProperty(
    '--vhfix',
    window.innerHeight + 'px'
  )
  setTimeout(() => {
    Emitter.emit('vhfixed')
  }, 100)
  // }, 10);
}
window.addEventListener('resize', onResize)
onResize()
